import { useExportFilesSearch } from '@/context/services/export_files/ExportFiles.service';
import { useUpdateURLSearchParams } from '@/hooks/useConvertToURLSearchParams';
import { useTranslation } from '@/i18n';
import { useToastAPI } from '@moneyforward/ap-frontend-components';
import { useCallback, useEffect, useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { ExportFilesTableProps } from '../index';

export function useExportFilesTablePagination() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const page = Number(searchParams.get('page')) || 1;
  const notify = useToastAPI();
  const { t } = useTranslation();

  const {
    data,
    pagination: _pagination,
    refetch,
  } = useExportFilesSearch({ page });

  const updateSearchParams = useUpdateURLSearchParams();

  const onPageChange = useCallback(
    (page: number) => {
      updateSearchParams({ page });
    },
    [updateSearchParams]
  );

  const pagination = useMemo(() => {
    return {
      ..._pagination,
      onChange: onPageChange,
    };
  }, [_pagination, onPageChange]);

  useEffect(() => {
    const currentPage = _pagination?.currentPage;
    if (currentPage) {
      onPageChange(currentPage);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_pagination?.currentPage]);

  useEffect(() => {
    const downloadProgressing = sessionStorage.getItem(
      'export_files_download_progressing'
    );
    if (!downloadProgressing) return;
    notify.pending({
      title: t('export_files_download_progressing_message'),
      duration: 3,
    });
    sessionStorage.removeItem('export_files_download_progressing');
  }, [notify, t]);

  const table: ExportFilesTableProps = useMemo(() => {
    return {
      data,
    };
  }, [data]);

  return { table, pagination, refetch };
}
